
/* ============================== src/components/NotifBell.jsx ============================== */
// src/components/NotifBell.jsx
import { useState, useRef, useEffect, useMemo, useCallback } from "react";
import NotifPanel from "./NotifPanel";
import { Ic } from "./Icons";
import { ICONS } from "./iconsData";
import {
  useNotificationsQuery,
  useMarkAllNotificationsReadMutation,
} from "../api/queries/notifications";

export default function NotifBell({ user, onNavigate }) {
  const notificationsQ = useNotificationsQuery();
  const markAllMutation = useMarkAllNotificationsReadMutation();

  // Стабилизируем данные для useMemo
  const notificationsRaw = notificationsQ.data?.notifications;
  const notifications = useMemo(
    () => notificationsRaw ?? [],
    [notificationsRaw],
  );
  const unreadFromServer = notificationsQ.data?.unreadCount ?? 0;

  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const myNotifs = useMemo(
    () => notifications.filter((n) => n.userId === user.id),
    [notifications, user.id],
  );
  const unread = useMemo(
    () => myNotifs.filter((n) => !n.read).length || unreadFromServer,
    [myNotifs, unreadFromServer],
  );

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target))
        setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const handleNavigate = useCallback(
    (notification) => {
      if (onNavigate) onNavigate(notification);
    },
    [onNavigate],
  );

  const handleMarkAll = useCallback(() => {
    markAllMutation.mutate();
  }, [markAllMutation]);

  return (
    <div className="bell-wrap" ref={wrapRef}>
      <button
        className={`icon-btn bell${unread ? " has" : ""}`}
        onClick={() => setOpen((v) => !v)}
      >
        <Ic d={ICONS.bell} size={17} />
        {unread > 0 && <span className="bell-count">{unread}</span>}
      </button>
      {open && (
        <NotifPanel
          list={myNotifs}
          currentUserId={user.id}
          markAllRead={handleMarkAll}
          onNavigate={handleNavigate}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
}
